import React from 'react';
import "./DataTableSection.scss";
import arrow from "../../Assets/image (68).png";
import img1 from "../../Assets/image (82).png";
import img2 from "../../Assets/image (83).png";
import img3 from "../../Assets/image (72).png";
import img4 from "../../Assets/image (71).png";

export default function DataTableSection() {
  const cardsData = [
    { id: 1, title: "75", subtitle: "Total Clients", percent: "25% (30 days)", image: img1 },
    { id: 2, title: "120", subtitle: "Visitors", percent: "15% (30 days)", image: img2 },
    { id: 3, title: "320", subtitle: "New Clients", percent: "35% (30 days)", image: img3 }
  ];

  return (
    <div>
    <div className='cards-section'>
      {cardsData.map(card => (
        <div className='stat-card' key={card.id}>
          <img src={card.image} height={60} width={60} alt="" />
          <div>
          <p>{card.subtitle}</p>
            <div className='title'>{card.title}</div>
           
            <div className='card-stats'>
              {/* <img src={arrow} width={20} alt="" /> */}
              <i class="fa-solid fa-arrow-down"></i>
              <span>{card.percent}</span>
            </div>
          </div>
        </div>
      ))}

<div className='stat-card' >
          <img src={img4} height={60} width={60} alt="" />
          <div>
          <p>Active Now</p>
            <h3>8,450 EGP</h3>
           
          </div>
        </div>
        <div>
  <button>
    <i className="fa-solid fa-upload" style={{ marginRight: "8px" }}></i>
    Export
  </button>
</div>


    </div>
    
    </div>

  );
}
